import { render } from "./p-address-input.vue?vue&type=template&id=d24d9c4e&scoped=true"
import script from "./p-address-input.vue?vue&type=script&lang=js"
export * from "./p-address-input.vue?vue&type=script&lang=js"

import "./p-address-input.vue?vue&type=style&index=0&id=d24d9c4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d24d9c4e"]])

export default __exports__